/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbAdmissionCoordinatorSummary
 */
export interface HchbAdmissionCoordinatorSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    worker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    phone?: string;
}

/**
 * Check if a given object implements the HchbAdmissionCoordinatorSummary interface.
 */
export function instanceOfHchbAdmissionCoordinatorSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbAdmissionCoordinatorSummaryFromJSON(json: any): HchbAdmissionCoordinatorSummary {
    return HchbAdmissionCoordinatorSummaryFromJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbAdmissionCoordinatorSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'worker_name': !exists(json, 'worker_name') ? undefined : json['worker_name'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function HchbAdmissionCoordinatorSummaryToJSON(value?: HchbAdmissionCoordinatorSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'worker_name': value.worker_name,
        'street': value.street,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'phone': value.phone,
    };
}

